import { Component } from "@angular/core";
import { ModuloEnum } from "../../../shared/enums/modulo.enum";
import { FuncionalidadeEnum } from "../../../shared/enums/funcionalidade.enum";
import { MenuComponent } from "../../../shared/components/menu/menu.component";
import { ListaFuncionalidadeComponent } from "../../../shared/components/lista-funcionalidade/lista-funcionalidade.component";

@Component({
    selector: 'app-implantacao-home',
    imports: [MenuComponent, ListaFuncionalidadeComponent],
    templateUrl: './implantacao-home.component.html',
    styleUrl: './implantacao-home.component.css'
})
export class ImplantacaoHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor() {
    this.moduloEnum = ModuloEnum.Implantacao;
  }
}